import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GENRES } from '@/mocks/manga';

export default function Hero() {
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (!keyword.trim()) return;
    navigate(`/?q=${encodeURIComponent(keyword.trim())}`);
  };

  return (
    <section className="relative w-full overflow-hidden bg-background-950">
      <img
        src="https://readdy.ai/api/search-image?query=stylized%20comic%20manga%20artwork%20collage%20background%2C%20dynamic%20action%20hero%20silhouette%20with%20floating%20manga%20panels%20and%20speed%20lines%2C%20warm%20coral%20orange%20and%20amber%20gold%20tones%2C%20bold%20ink%20linework%2C%20energetic%20dynamic%20composition%2C%20artistic%20illustration%20for%20a%20manga%20reading%20portal%2C%20high%20contrast%2C%20cinematic%20atmosphere&width=1600&height=900&seq=manga-hero-01&orientation=landscape"
        alt="免费51漫画热漫画卷背景图"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50"></div>

      <div className="relative mx-auto flex w-full max-w-5xl flex-col items-center px-4 pb-24 pt-16 text-center md:px-6 md:pb-32 md:pt-24">
        <span className="rounded-full border border-accent-300/60 bg-background-950/40 px-4 py-1.5 text-sm font-medium text-accent-200 backdrop-blur">
          <i className="ri-flashlight-fill mr-1 text-accent-300"></i>
          今日新增 12 部 · 更新 45 话
        </span>
        <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
          按标签选漫画，<span className="text-accent-300">追更更方便</span>
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100/90 md:text-lg">
          热血类、搞笑类、少女漫、少年漫、完结作品、汉化组一应俱全。用清晰的类型标签帮你快速锁定心仪的作品，不错过每一次更新。
        </p>

        <form onSubmit={handleSearch} className="mt-8 flex w-full max-w-xl items-center gap-2">
          <label className="sr-only" htmlFor="hero-search">搜索漫画</label>
          <div className="flex h-12 flex-1 items-center rounded-full border border-white/20 bg-background-50/95 px-4 shadow-sm backdrop-blur">
            <i className="ri-search-line mr-3 text-base text-foreground-600"></i>
            <input
              id="hero-search"
              type="search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="输入漫画名、作者或类型"
              className="h-12 w-full bg-transparent text-base text-foreground-900 placeholder:text-foreground-500 focus:outline-none"
            />
          </div>
          <button
            type="submit"
            className="h-12 shrink-0 whitespace-nowrap rounded-full bg-primary-500 px-7 text-base font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            搜索
          </button>
        </form>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          <span className="text-sm text-background-200">热门标签：</span>
          {GENRES.slice(0, 6).map((g) => (
            <a
              key={g.id}
              href={`/category/${g.id}`}
              className="rounded-full border border-white/20 bg-background-950/30 px-3 py-1 text-sm text-background-100 backdrop-blur transition-colors hover:border-accent-300 hover:text-accent-200"
            >
              {g.name}
            </a>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <a
            href="#categories"
            className="whitespace-nowrap rounded-full bg-accent-500 px-6 py-3 text-sm font-semibold text-background-950 transition-colors hover:bg-accent-400"
          >
            <i className="ri-price-tag-3-line mr-1"></i>
            按类型找漫画
          </a>
          <a
            href="#latest"
            className="whitespace-nowrap rounded-full border border-white/30 bg-transparent px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-white/10"
          >
            <i className="ri-fire-line mr-1"></i>
            看最新更新
          </a>
        </div>
      </div>
    </section>
  );
}